import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const AbbreviatedNumber = lazy(() => import('.'))

class AbbreviatedNumberComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['number', 'format']
  }

  override render() {
    const number = this.prop('number')
    const format = this.getAttribute('format') || '%s'

    return (
      <RootProviders>
        <AbbreviatedNumber
          number={parseInt(number, 10)}
          formatTooltip={(value) => format.replace('%s', value)}
        />
      </RootProviders>
    )
  }
}

customElements.define('abbreviated-number', AbbreviatedNumberComponent)
